/**
 * Project Logo Component
 * Dynamically displays the correct logo based on project configuration
 * Logo is loaded from config/projects/[project]/logo.png
 * Uses standardized sizes from imageConstants
 */

import { projectConfig } from '../../config/projectConfig';
import { IMAGE_SIZES } from '../../constants/imageConstants';

interface ProjectLogoProps {
  className?: string;
  alt?: string;
  style?: React.CSSProperties;
  size?: 'sidebar' | 'header' | 'card' | 'large';
}

const ProjectLogo: React.FC<ProjectLogoProps> = ({ className = '', alt, style, size = 'sidebar' }) => {
  const defaultSize = IMAGE_SIZES.logo[size];

  return (
    <img
      src={projectConfig.logo}
      alt={alt || `${projectConfig.displayName} Logo`}
      className={className}
      style={{
        width: defaultSize.width,
        height: defaultSize.height,
        objectFit: 'contain',
        ...style,
      }}
    />
  );
};

export default ProjectLogo;
